module.exports = __webpack_public_path__ + "static/media/ky.96d7cc25.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ky.svg
// module id = 2136
// module chunks = 0